import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { GlobalContext } from "../Context/GlobalState";
const ProtectedRoute = ({ allowedTypes, children }) => {
  const { user } = useContext(GlobalContext);
  const location = useLocation();
  const sessionUser = JSON.parse(sessionStorage.getItem("user"));
  const activeUser = user || sessionUser;

  const userType = activeUser?.user_type || activeUser?.us_type;
  const hasActiveSession = Boolean(activeUser?.token_login || activeUser?.user_id);

  if (!activeUser || !hasActiveSession) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  if (allowedTypes?.length && !allowedTypes.includes(userType)) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return children;
};

export default ProtectedRoute;
